import styled from 'styled-components';

import { getPurpurSpacing } from '@telialt/common-theme/src/purpurSelectors';

export const Dot = styled.li<{ $isActive: boolean }>`
    height: ${({ $isActive }) => ($isActive ? '12px' : '6px')};
    width: ${({ $isActive }) => ($isActive ? '12px' : '6px')};
    background-color: #e3e3e3;
    border-radius: 50%;
    cursor: pointer;
    transform: translateY(-50%);
    transition:
        width 0.15s ease-in-out,
        height 0.15s ease-in-out;
`;

export const Dots = styled.ul`
    margin: ${getPurpurSpacing('400')} 0 ${getPurpurSpacing('200')};
    justify-content: center;
    padding: 0;

    display: flex;
    flex-wrap: nowrap;
    gap: ${getPurpurSpacing('200')};
    list-style: none;
`;
